import { Button, ButtonProps, Spinner } from '@isbj-redesign/frontend-components'
import IconProps from '@isbj-redesign/icons/props'
import React, { ComponentType, ReactNode } from 'react'
import classes from './Spinner.module.css'

export type Props = Omit<ButtonProps, 'children'> & {
    label: ReactNode
    icon?: ComponentType<IconProps>
    spinning?: boolean
}

export default function SpinningButton({ label, icon: Icon, spinning, disabled, ...props }: Props) {
    return (
        <Button {...props} disabled={spinning || disabled}>
            {spinning ? <Spinner className={`${classes.spinner} mr-1`} /> : Icon ? <Icon className="mr-1" /> : null} {label}
        </Button>
    )
}
